import React from "react";
import userDefaultPhoto from "../assets/img/default-user-image.png";

const ManagersComponent = (props) => {
  const {t} = props
  return (
    <ul className="list-unstyled team-members">
      {
        props.managerList.length > 0
          ?
          props.managerList.map((manager, key) => {
            return (manager.manager.managerID != props.userID ?
              <li key={key}>
                <div className="row">
                  <div className="col-xs-3">
                    <div className="avatar" id="employeeManagerAvatar">
                      <img src={manager.manager.managerPhoto ? "data:image/png;base64," + manager.manager.managerPhoto : userDefaultPhoto} className="img-circle img-no-padding img-responsive" />
                    </div>
                  </div>
                  <div className="col-xs-6">
                    <span className="managerName" id="employeeManagerName">{manager.manager.managerName}</span>
                    <br />
                  </div>
                  <div className="col-xs-3 text-right"></div>
                </div>
              </li> : props.managerList.length == 1 ? <li key={new Date()}><span id="employeeNoManager">{t('managerNotDefined')} </span></li> : null)
          })
          :
          <li key={new Date()}><span id="employeeNoManager">{t('managerNotDefined')} </span></li>
      }
    </ul>
  );
};



export default ManagersComponent;
